import EliaButton from "../EliaButton";

export const buildSummaryRequest = (configurationName, sourceContent) => `
Tu es un expert en création de présentations PowerPoint professionnelles.

Objectif:
Génère un fichier PowerPoint téléchargeable à partir du texte d'analyse fourni ci-dessous, puis retourne son lien de téléchargement.

Instructions critiques:
- N'analyse pas la configuration.
- Ne relance pas d'analyse de configuration.
- N'appelle pas d'agent ou d'outil de configuration.
- Utilise uniquement le texte déjà analysé dans "Contenu source".
- Ton objectif est uniquement de produire un PPTX et de retourner son lien.

## Contenu source
Configuration analysée: ${configurationName || "configuration"}

${sourceContent}

## Structure de la présentation (10-12 slides)
1. Slide titre - Nom de la configuration, date, résumé en une phrase
2. Synthèse éxécutive - KPIs clés en grands chiffres
3. Répartition par criticité - Graphique en donut/camembert avec chiffres visibles
4. Types de redondance détectés - Graphique en barres horizontales
5. Volumes: règles à supprimer vs optimiser - Graphique en barres comparatif
6. Risques prioritaires - Top 5 sous forme de tableau ou cartes visuelles
7. Analyse détaillée - Points clés de l'analyse en 2 colonnes
8. Actions recommandées - Timeline ou liste numerotée priorisée
9. Conclusion et prochaines étapes - Slide sombre de cloture

## Exigences visuelles
- Chaque graphique doit afficher ses valeurs numériques directement sur le graphique
- Minimum 1 élement visuel par slide: graphique, icone, stat callout ou tableau
- Ajoute des graphiques uniquement si les données numeriques sont présentes dans le texte source

## Format de reponse
Génère le fichier et termine ta réponse avec éxactement cette ligne, sans modification:
PPTX_DOWNLOAD_URL: <url>
`;

export function EliaSummaryAction({ configurationName, isLoading, hasDownload, error, onDownload }) {
  return (
    <div className="elia-summary-action">
      <div className="elia-summary-action-icon" aria-hidden="true">
        <EliaButton status="active" />
      </div>
      <div className="elia-summary-action-content">
        <div className="elia-summary-action-title">Obtenir une synthèse de votre configuration</div>
        <div className="elia-summary-action-subtitle">Générer avec Elia{configurationName ? ` pour ${configurationName}` : ""}</div>
        {error && <div className="elia-summary-action-error">{error}</div>}
      </div>
      <button type="button" className="elia-summary-action-button" onClick={onDownload} disabled={isLoading}>
        {isLoading ? "Génération..." : hasDownload ? "Télécharger" : "Télécharger"}
      </button>
    </div>
  );
}
